/**
 * Batch Genealogy — batch status legend (UI config).
 *
 * The four batch-status values and their colours/labels, exactly as defined in
 * the FSD legend (Released / Deviation-closed / Under investigation / Test
 * failure). This is presentation config shared by the graph, table, detail
 * drawer and the report legend — it is NOT genealogy data (all lineage/batch
 * data comes from the middleware via ./api).
 *
 * The `status` returned by the API for every node/detail/deviation is one of
 * these keys; components look it up here for the colour and label.
 */
export const STATUS = {
  released:      { key: 'released',      label: 'Released',            color: '#16a34a', bg: '#dcfce7', text: '#15803d' },
  deviation:     { key: 'deviation',     label: 'Deviation (closed)',  color: '#7c3aed', bg: '#ede9fe', text: '#6d28d9' },
  investigation: { key: 'investigation', label: 'Under investigation', color: '#f59e0b', bg: '#fef3c7', text: '#b45309' },
  testFailure:   { key: 'testFailure',   label: 'Test failure',        color: '#dc2626', bg: '#fee2e2', text: '#b91c1c' },
};

// Role of a stage, shown in the lineage graph's stage rail and the batch detail
// drawer. The middleware tags the final stage's step label with "Final"
// (e.g. "Step E · Final"); every other stage is an intermediate.
export const stageRole = (step) => (step && /final/i.test(step.label || '') ? 'Final Product' : 'Intermediate');

export default STATUS;
